export const allLabelWithBlank = { value: "", label: "All" }
export const allLabelWithZero = { value: 0, label: "All" }
export const selectLabelWithZero = { value: 0, label: "Select..." }
